import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {Atoms, Charts} from 'components';
import { getInterproDomain } from 'api/fetch_data';

class IvalInterproDomain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            plotData: []
        };
        this.header = [
            {key: 'feature', content: 'Feature'},
            {key: 'domain_name', content: 'Name'},
            {key: 'start', content: 'Start'},
            {key: 'end', content: 'End'},
            { key: 'search', content: 'Search same domain gene' }
        ];
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        this.__ignoreLastFetch = true;
    }

    fetchData = () => {
        const { genomeAbbr, id, recordType } = this.props;
        getInterproDomain(genomeAbbr, id, recordType).then(data => {
            if (!this.__ignoreLastFetch) {
                const dataSource = data.map(item => ({
                    feature: item['feature'],
                    domain_name: <a
                        href={`https://www.ebi.ac.uk/interpro/signature/${item['domain_name']}`}>{item['domain_name']}</a>,
                    start: item['start'],
                    end: item['end'],
                    search: <Link to={{
                        pathname: '/search/interpro_domain',
                        state: {'searchText': item['domain_name'], "species": "All", "genome": "All", "assemble": "All"}
                    }}>Search</Link>
                }));
                const plotData = data.map(item => ({
                    group: item['feature'],
                    start: item['start'],
                    end: item['end'],
                    strand: item['strand'],
                    name: item['domain_name'],
                    blocks: [[item['start'], item['end']]],
                }));
                this.setState({ dataSource, plotData });
            }
        });
    };

    render() {
        const { dataSource, plotData } = this.state;
        const { ival, recordType } = this.props;

        if (dataSource.length === 0) {
            return null;
        }
        
        const edix = {
            'Trans': ival.exon_len,
            'Prot': ival.aa_num
        };
        return (
            <Atoms.ExpansionInfoCard
                title="InterPro domain"
                mainContent={
                    <Charts.GeneStructure
                        bpStart={0}
                        bpEnd={edix[recordType]}
                        heightPerDataGroup={20}
                        width={1000}
                        padding={[10, 50, 30, 150]}
                        dataSource={plotData}
                    />
                }
                expansionContent={
                    <Atoms.CustomTable
                        columns={this.header}
                        dataSource={dataSource}/>
                }
            />
        );
    }
}

IvalInterproDomain.propTypes = {
    ival: PropTypes.object,
    genomeAbbr: PropTypes.string,
    speciesAbbr: PropTypes.string,
    id: PropTypes.string,
    recordType: PropTypes.string
};

export default IvalInterproDomain;

